import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import ModuleTemplate from '../components/templates/Module';

const Module = () => {
  return <AuthWrapper renderProps={ModuleTemplate} />;
};

export default Module;
